<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Power Consumption
                </v-card-title>

                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card>
                            <v-card-text>
                                <date-range-selector v-model="dateRange"></date-range-selector>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 v-if="data">
                        <vue-plotly disable-responsive :data="data" :layout="layout" :options="options" ref="plotly"/>
                    </v-flex>
                    <v-flex xs12 v-if="data2">
                        <vue-plotly disable-responsive :data="data2" :layout="layout2" :options="options2" ref="plotly"/>
                    </v-flex>
                    <v-flex xs12 v-if="chillersData" v-for="cd in chillersData">
                        <vue-plotly disable-responsive :data="cd" :layout="layout" :options="options" ref="plotly"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>





    </v-layout>
</template>

<script>
    import {callAPI} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import DateRangeSelector from "../components/DateRangeSelector";
    import moment from 'moment'
    export default {
        name: 'PowerConsumption',
        components: { VuePlotly,DateRangeSelector},

        data () {
            return {
                timeout:null,
                dateRange: {start: '2019-08-27', end: moment().subtract(1, "days").format('YYYY-MM-DD')},
                forcedBlue:["2019-10-31 00:00:00","2019-10-29 00:00:00"],
                loading:true,
                equipment: 'ACPC-2',
                data:null,
                data2:null,
                chillersData:null,
                options: {},
                options2: {},
                layout:{
                    hovermode: 'closest',
                    title: "Relation of Outdoor Temperature and Energy Consumption",
                    xaxis: {
                        title: 'Average outdoor air temperature (°C)',
                        range:[21,35]
                    },
                    yaxis: {
                        title: 'Total energy consumption (kWh)',
                        rangemode:'tozero'
                    }
                },
                layout2:{
                    hovermode: 'closest',
                    title: "Relation of CDD and Energy Consumption",
                    xaxis: {
                        title: 'CDD',
                    },
                    yaxis: {
                        title: 'Total energy consumption (kWh)',
                        rangemode:'tozero'
                    }
                }
            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    ar3.push(ar1[i] + ar2[i]);
                return ar3;
            },
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.doRefresh,200);
            },
            doRefresh() {
                let me=this;
                me.loading=true;
                let promises=[];
                let timestamp=null;
                let totalPower=null;
                let avgTemp=null;
                let cdd=null;
                promises.push(callAPI('data/',
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'equipment_name': 'ACPC-1',
                        'agg': 'D',
                        'agg_op': 'mean',
                        'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                        'sensor_names': ['Outdoor_Air_Temperature']
                    }
                ))
                promises.push(callAPI('data/',
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'equipment_name': 'Weather',
                        'agg': 'D',
                        'agg_op': 'mean',
                        'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                        'sensor_names': ['CDD']
                    }
                ))
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type==='chiller'){
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                                'sensor_names': ['Comp_Power']
                            }
                        ))
                    } else if(equip.equipment_type==='pump'){
                        promises.push(callAPI('data/',
                            {
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_name': equip.equipment_name,
                                'agg': 'D',
                                'agg_op': 'sum',
                                'date_range':[me.dateRange.start, me.dateRange.end+" 23:59"],
                                'sensor_names': ['KW']
                            }
                        ))
                    }
                }




                Promise.all(promises).then(function(reses) {
                    let chillersData=[];
                    for (let res of reses){
                        if(!timestamp){
                            timestamp=res.data.timestamp;
                        }
                        if(res.data['Outdoor_Air_Temperature']){
                            avgTemp=res.data['Outdoor_Air_Temperature'];
                        } else if(res.data['CDD']){
                            cdd=res.data['CDD'];
                        }else {
                            if(!totalPower){
                                if(res.data['Comp_Power']){
                                    totalPower=res.data['Comp_Power'];
                                } else if (res.data['KW']){
                                    totalPower=res.data['KW'];
                                }
                            } else {
                                if(res.data['Comp_Power']){
                                    totalPower=me.addArrays(totalPower,res.data['Comp_Power'])
                                } else if (res.data['KW']){
                                    totalPower=me.addArrays(totalPower,res.data['KW'])
                                }
                            }
                            if(res.data['Comp_Power']){
                                let preAvgTemp=[];
                                let postAvgTemp=[];
                                let prePower=[];
                                let postPower=[];
                                let preLabels=[];
                                let postLabels=[];
                                for (let k in timestamp){
                                    if(timestamp[k]<="2019-09-18 00:00:00"||me.forcedBlue.includes(timestamp[k])){
                                        preAvgTemp.push(avgTemp[k]);
                                        prePower.push(res.data['Comp_Power'][k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                                        preLabels.push(timestamp[k].substring(0, 10));
                                    } else {
                                        postAvgTemp.push(avgTemp[k]);
                                        postPower.push(res.data['Comp_Power'][k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                                        postLabels.push(timestamp[k].substring(0, 10));
                                    }
                                }
                                chillersData.push( [
                                    {x: preAvgTemp, y: prePower, type: 'scattergl', mode: 'markers' ,name: JSON.parse(res.config.data)["equipment_name"]+" before optimisation",hovertext:preLabels},
                                    {x: postAvgTemp, y: postPower, type: 'scattergl', mode: 'markers',name:JSON.parse(res.config.data)["equipment_name"]+" after optimisation",hovertext:postLabels}
                                ]);
                            }
                        }

                    }
                    let preAvgTemp=[];
                    let postAvgTemp=[];
                    let preCDD=[];
                    let postCDD=[];
                    let preTotalPower=[];
                    let postTotalPower=[];
                    let preLabels=[];
                    let postLabels=[];

                    for (let k in timestamp){
                        if(timestamp[k]<="2019-09-18 00:00:00"||me.forcedBlue.includes(timestamp[k])){
                            preAvgTemp.push(avgTemp[k]);
                            preCDD.push(cdd[k]);
                            preTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                            preLabels.push(timestamp[k].substring(0, 10));
                        } else {
                            postAvgTemp.push(avgTemp[k]);
                            postCDD.push(cdd[k]);
                            postTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                            postLabels.push(timestamp[k].substring(0, 10));
                        }
                    }

                    me.data = [
                        {x: preAvgTemp, y: preTotalPower, type: 'scattergl', mode: 'markers' ,name:"Plant before optimisation",hovertext:preLabels},
                        {x: postAvgTemp, y: postTotalPower, type: 'scattergl', mode: 'markers',name:"Plant after optimisation",hovertext:postLabels}
                    ];
                    me.data2 = [
                        {x: preCDD, y: preTotalPower, type: 'scattergl', mode: 'markers' ,name:"Plant before optimisation",hovertext:preLabels},
                        {x: postCDD, y: postTotalPower, type: 'scattergl', mode: 'markers',name:"Plant after optimisation",hovertext:postLabels}
                    ];
                    me.chillersData=chillersData;
                    me.loading=false;
                });

            }
        },
        watch: {
            dateRange () {
                this.refresh()
            }
        },
        mounted() {
            this.refresh();
        }


    }
</script>
